export const isBrowser = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
//# sourceMappingURL=is-browser.js.map